<template>
  <li
    v-if="canSeeMenu"
    class="nav-item"
    :class="{
      'active': isActive,
      'disabled': item.disabled
    }"
  >
    <b-link
      v-bind="linkProps"
      class="d-flex align-items-center"
    >
      <feather-icon :icon="item.icon || 'CircleIcon'" />
      <span class="menu-title text-truncate">{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
import { useUtils as useAclUtils } from '@core/libs/acl'
import { BLink, BBadge } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'
import { mapGetters } from 'vuex';


export default {
  components: {
    BLink,
    BBadge,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(props.item)
    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuLink } = useAclUtils()

    return {
      isActive,
      linkProps,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuLink,

      // i18n
      t,
    }
  },
  mounted() {
  },
  computed: {
    ...mapGetters({
      'user': 'auth/getActiveUser'
    }),
    canSeeMenu() {
      let role = this.item.role;

      // check if menu role is not empty
      if (role !== '' && role !== undefined) {
        // is menu role array
        if (Array.isArray(role)) {
          // check if user role included in menu roles
          if (role.includes(this.user.role)) {
            return true;
          }

          // false if user roles is not included
          return false
        } else {
          // menu role is single item which is string
          if (this.user.role === role) {
            return true
          } else {
            return false
          }
        }
      }

      // default allow menu to visible
      return true
    }
  }
}
</script>
